module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/make-video_3-f6678fe79fd5bb09bb497bf0446f5301.png";